const mapCard = (json) => {
    const { id, name, description, kpisCounter, rulesCounter, crCounter } = json;
    return [
        [
            {
                labels: ["id"],
                value: id,
                type: "string",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["packageName"],
                value: name,
                type: "string",
                basis: "35%",
            },
        ],
        [
            {
                labels: ["description"],
                value: description,
                type: "string",
                basis: "50%",
            },
        ],
        [
            {
                label: ["kpisCounter"],
                value: {
                    id: "kpisCounter",
                    color: "blue",
                    name: kpisCounter,
                    customParam: {},
                    link: {
                        to: `/:locale(pt|en|lt|es|ro|fr)?/settings/kpis`,
                        filter: [
                            {
                                filters: [{ value: `${id}` }],
                                column: "packageId",
                                operator: "equals",
                            },
                        ],
                    },
                },
                type: "colorize-link",
                align: "center",
                basis: "10%",
            },
        ],
        [
            {
                label: ["rulesCounter"],
                value: {
                    id: "rulesCounter",
                    color: "blue",
                    name: rulesCounter,
                    customParam: {},
                    link: {
                        to: `/:locale(pt|en|lt|es|ro|fr)?/settings/nc_rules`,
                        filter: [
                            {
                                filters: [{ value: `${id}` }],
                                column: "packageId",
                                operator: "equals",
                            },
                        ],
                    },
                },
                type: "colorize-link",
                align: "center",
                basis: "10%",
            },
        ],
        [
            {
                label: ["crCounter"],
                value: {
                    id: "Edit",
                    color: "blue",
                    name: crCounter,
                    customParam: {},
                    link: {
                        to: `/:locale(pt|en|lt|es|ro|fr)?/settings/custom_reports`,
                        filter: [
                            {
                                filters: [{ value: `${id}` }],
                                column: "packageId",
                                operator: "equals",
                            },
                        ],
                    },
                },
                type: "colorize-link",
                align: "center",
                basis: "10%",
            },
        ],
        [
            {
                label: ["edit"],
                value: {
                    id: "Edit",
                    color: "blue",
                    name: "Edit",
                    __typename: "PackageNavigation",
                    customParam: { id: `${id}` },
                    link: {
                        to: `/:locale(pt|en|lt|es|ro|fr)?/settings/:section/packages-association/:id/package_rules`,
                    },
                },
                type: "colorize-link",
                align: "center",
                basis: "10%",
            },
        ]
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["Identifier"],
        align: "left",
        basis: "10%",
        columnName: "id",
        sortable: true,
    },
    {
        label: ["Package Name"],
        basis: "35%",
        align: "left",
        columnName: "name",
        sortable: true,
    },
    {
        label: ["Description"],
        align: "left",
        columnName: "description",
        sortable: true,
        basis: "50%",
    },
    {
        label: ["Kpis"],
        align: "center",
        columnName: "kpisCounter",
        basis: "10%",
    },
    {
        label: ["Rules"],
        align: "center",
        columnName: "rulesCounter",
        basis: "10%",
    },
    {
        label: ["Custom Reports"],
        align: "center",
        columnName: "crCounter",
        basis: "10%",
    },
    {
        label: ["Associate"],
        align: "center",
        columnName: "edit",
        basis: "10%",
    },
];

const packageMapper = {
    map: mapper,
    header,
};

export default packageMapper;
